import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import IndexSectionNavigations13 from "../components/navigations/IndexSectionNavigations13";
import IndexSectionFooters7 from "../components/footers/IndexSectionFooters7";

const meta = {
  title: "特定商取引法に基づく表記 | らくらくQRシステム",
  meta: [
    {
      name: "description",
      content:
        "特定商取引法に基づく表記 - らくらくQRシステムの販売事業者情報を掲載しています。",
    },
  ],
};

export default function Legal() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta} />
      </HelmetProvider>
      <IndexSectionNavigations13 />
      <main>
        {/* ヒーローセクション */}
        <section className="relative pt-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-5xl xs:text-6xl md:text-5xl font-bold text-gray-900 mb-4">
                特定商取引法に基づく表記
              </h1>
              <p className="mt-4 text-lg text-gray-600">
                特定商取引法第11条に基づき、以下のとおり表示いたします。
              </p>
            </div>

            <div className="max-w-4xl mx-auto mt-16 space-y-6">
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">販売事業者</h2>
                <p className="text-gray-600 leading-relaxed">合同会社 HCloud</p>
              </div>

              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">所在地</h2>
                <p className="text-gray-600 leading-relaxed">
                  〒105-0013
                  <br />
                  東京都港区浜松町2-2-15
                </p>
              </div>

              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">連絡先</h2>
                <p className="text-gray-600 leading-relaxed">
                  メールアドレス: contact@qr-system.hcloud.ltd
                  <br />
                  受付時間: 平日10:00〜19:00
                </p>
              </div>

              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">料金</h2>
                <p className="text-gray-600 leading-relaxed">
                  月額利用料: 4,620円（税込）
                  <br />
                  初期費用: 0円
                  <br />※ API連携等のカスタマイズは別途お見積り
                </p>
              </div>

              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">支払方法</h2>
                <p className="text-gray-600 leading-relaxed">
                  クレジットカード決済（Stripe）
                  <br />
                  銀行振込（Stripe）
                </p>
              </div>

              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  解約・返品について
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  サービスの解約は当月末までにお申し出ください。
                  <br />
                  デジタルサービスのため返品は承っておりません。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <IndexSectionFooters7 />
    </React.Fragment>
  );
}
